export const isActiveUser = (info) => {
  if (
    !info.validaciones.codigo ||
    !info.contracto.contrato ||
    !info.afiliado1.titular
  ) {
    return false;
  }

  return true;
};
